module.exports = __webpack_public_path__ + "img/woosports.3cdcc7b0.png";